const lang = {
  contact: '連絡先',
  experience: '職務経歴',
  education: '学歴',
  skills: 'スキル',
  about: '自己紹介'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja.js